- title: Kişisel Gelişim Programları
  list:
  - title: Beden Dili ve İletişimdeki Etkisi
    text: Beden dili ile verilen mesajların karşı taraf üzerindeki etkisinin katılımcılar tarafından anlaşılmasının sağlanması
    list:
    - İnsan Hayatında İletişimin Önemi
    - Kişilerarası İlişkilerde İletişim Tarzlarımız
    - İletişimde İlk Göze Çarpan Dış Görünüm ve Beden Dili
    - Göz Teması Kuramasaydık Ne Yapardık?
    - Konuşurken Nasıl Bir Beden Dili Sergiliyoruz?
    - Hareketlerimizin Analizi
    - Sözsüz İletişim Becerilerini Geliştirme
  - title: Bireysel Kalitemizi Geliştirmek
    text: Çevremizdeki değişim, bu değişimin iş dünyasına ve bireylere yansıması doğrultusunda bireysel kalitemizi geliştirmek için etken olan insan, proses ve teknoloji gibi temel dinamiklerin önemi ve kaliteli iş çevresinin sağlanmasındaki rolü ile bu temel dinamiklerin birbiriyle etkileşimleri
    list:
    - Bireysel Liderlik
    - Kişisel Hedefler Belirlemek
    - Kişisel Hedefler ve İş Hedeflerinin Senkronizasyonu
    - Gerçek Ortaklık
    - Ekip Anlayışı
    - Sistem Odaklılık
    - Kişisel Hatalardan Öğrenmek
    - Empati
    - Kaynakları İyi Kullanmak
    - Süreç Yönelimlilik
    - İşgücümüzü Etkin Kullanmak
    - Performansımızı Geliştirecek Hedefler Belirlemek
    - Beyin Fırtınası
    - Neden - Sonuç Diyagramları
    - Etkin İletişim Kurmak
    - Çatışma Yönetimi
  - title: Çatışma Yönetimi
    text: İnsan ilişkilerinde yaşanan çatışmanın hayatın her boyutuna yansıyan etkilerini irdelemek ve her düzeyde iletişim kurma becerisini geliştirmek, bireysel ve organizasyonel hedef ve değer anlayışındaki çatışmanın özünü anlamak ve yine aynı düzlemde bireysel ve kurumsal uzlaşma stratejileri geliştirmenin yöntemleri
    list:
    - Teknik Olarak İletişim
    - İletişim ve Etkileşim Boyutu
    - Organizasyonel Davranış ve Yönetimi
    - "\"Çağdaş Organizasyon\" İçin Davranış Modelleri"
    - "Kabuk Değişiminin Sancısı: Organizasyonel Direnç"
    - Çatışma Nedenleri, Türleri
    - Kişisel Tavır, Değer Yargıları ve Tutumların Analizi
    - Uzlaşma Teknikleri
    - Uzlaşmada Yönetimsel İlkeler
    - Çatışmaları Yöneten Bir Firma Kültürü
  - title: Değişime Uyum
    text: Kurumun tüm iş ve işlemlerinde, çalışanların, kişisel ve kurumsal ilişkilerinde ve iletişimlerinde; Ar-Ge, planlama, karar verme, uygulama, üretim, satış, pazarlama, takip, kontol ve geribildirim süreçlerinde, kurumsal bir bütünlük ve takımsal bir ahenk sağlamak amacıyla değişime uyumu tüm detayları ile katılımcılara aktarmak
    list:
    - Küresel Bir Vizyona Sahip Olmak
    - Yenilikçi, Sıradışı, Yaratıcı Çözüm Üretebilmek
    - Değişime Inanmak
    - Mevcut Sistemi Statükocu Bir Düşünce Ile Korumaktan ve Değişme Direnmekten Vazgeçmek
    - Değişimin Tüm Laretal Etkilerinin Farkında Olmak
    - Değişimin Gerektirdiği Esnekliğe Sahip Olmak
    - Değişimin Gerektirdiği Doğru Stratejiyi, Kurum Kültürü Çerçevesinde Uyumlu Bir Takımdaşlıkla Uygulayabilmek
  - title: Eğiticinin Eğitimi
    text: Katılımcılara kurumsal değerleri göz önüne alarak bilgi paylaşımı ve aktarımını yapabilmelerini uygulamalar ve örneklerle göstermek
    list:
    - Eğitim, Yetiştirme ve Geliştirme
    - Eğitimi Gerektiren Durumlar
    - Eğitimin Amaçları
    - Eğitim İşlevini Etkileyen Organizasyonel Faktörler
    - Eğitim Politikasını Belirleyen Faktörler
    - Eğitim Süreci
    - Eğitim İhtiyacı Analizi
    - Eğitim İhtiyacının Belirlenmesinde Veri Kaynakları
    - Eğitim Programlarının Geliştirilmesi
    - İşletmelerde Uygulanan Eğitim Yöntemleri
    - Eğitimin Gerçekleştirilmesi, Sunuş Becerileri
    - İletişimi Etkileyen Temel Faktörler
    - Engellerin Giderilmesi İçin İletişim Kurma
    - İletişim Becerileri
    - Davranış Biçimleri
    - Öğretim Modelleri
    - Eğitimin Değerlendirilmesi
  - title: Empatik İletişim
    text: Şirket içinde kişiler arası ilişkilerin, kişilik tipleri ve davranış özelliklerinin empatik bir anlayış ile olumlu yönde geliştirilmesi
    list:
    - İletişim ve Kültür
    - Kültürel Farklılıklar
    - Kişilikler, Temel Özellikler ve Kişilik Tipleri
    - Davranışlar ve Güvenli Davranış Özellikleri
    - Etkin Dinleme ve Etkin Konuşma
    - Kadın ve Erkek Dili
    - Kurum içi İlişkiler ve Empati
  - title: Etkili İletişim Yöntemleri
    text: Kişilerarası ilişkileri tanımlamak, geliştirmek ve uygulamak, şirket kültürü ve stratejisini destekleyerek kurum içi barışı sağlamak, kurumsal uzlaşma stratejileri geliştirmek
    list:
    - Kurum içi İletişim
    - İletişimde Farklı Bakış Açılarından Bakmak
    - İnsan İlişkilerinde Karşılaşılabilecek Engelleri Çözümleyebilecek Analizci Bir Bakışa Sahip Olmak
    - Güçlü ve Zayıf Yönlerimizin Farkında Olmak
    - İletişime Etki Eden Özelliklerimiz
    - Baskın Kişilik Özelliklerimiz
    - Doğru Anlamak ve Anlaşılmak
    - Bireysel ve Kurumsal Uzlaşma Stratejileri Geliştirmek
    - Şirket içi Çatışmaları Önlemenin Yollarını Tanımlamak
    - Organizasyonel Davranış
    - Kişisel Tavır, Değer ve Tutumların Analizi
    - Kişilerarası Amaç, Hedef ve Değer Yargıları
  - title: İşyeri Psikolojisi
    text: Çalışanların kendilerini daha rahat ifade etmeleri, kişilerarası ilişkiler, işbirliği ve içsel motivasyonun arttırılması
    list:
    - Şirket Mensubu Olarak Bireysel Misyon
    - Bu Işyerinde Çalışmanın Güçlü Yanlarının Belirlenmesi
    - Bu Işyerinde Yaşanan Zorlukların Belirlenmesi
    - Kişilerarası İlişkiler
    - Çalışanlar Arası İşbirliği ve Güven
    - İçsel Motivasyonun Arttırılması
    - Bireysel Performansın Geliştirilmesi
    - İşyerinde Stres
    - İş Güvenliği ve İşgören Sağlığı
  - title: Kendine Güveni Geliştirme
    text: Kurumsal temel değer ve ilkelerle örtüşen kişisel prensipler geliştirme ve zor anlarda bu ilkelere uymanın sağlanması
    list:
    - İlkelerine Bağlı Kalarak Başkalarının Güven ve Saygısını Kazanmak
    - Zor Zamanlarda Başaracağına Olan Inancını Kaybetmemek
    - Zor Olan Doğru ve Etkili Kararları Zor Anlarda Dahi Alabilmek
    - Pes Etmeden Devam Etmek
    - Kurumsal Hedeflere Olan Inancını Yüksek Tutmak
    - Başarıya ve Çözüme Odaklanmak
    - Zor Anları, Kendini Kötü Hissetme Duygusuna Kapılmadan Yüksek Bir Motivasyonla Geçebilmek
  - title: Kişilerarası İlişki Becerilerini Geliştirme
    text: Kişilerarası çıkabilecek iletişim engelleri ve çatışmaların uzlaşma stratejileri geliştirerek aşılması, kişilerin amaç, hedef ve değer yargıları bütünlüğünü sağlayarak, çalışanlar arası işbirliği ve güvenin oluşturulması
    list:
    - İletişimde Farklı Bakış Açılarından Bakmak
    - İnsan İlişkilerinde Karşılaşılabilecek Engelleri Çözümleyebilecek Analizci Bir Bakışa Sahip Olmak
    - İşyerinde Stres
    - Güçlü ve Zayıf Yönlerimizin Farkında Olmak
    - Baskın Kişilik Özelliklerimiz
    - Bireysel ve Kurumsal Uzlaşma Stratejileri Geliştirmek
    - Şirket içi Çatışmaları Önlemenin Yollarını Tanımlamak
    - Organizasyonel Davranış
    - Kişisel Tavır, Değer ve Tutumların Analizi
    - Kişilerarası Amaç, Hedef ve Değer Yargıları
    - Çalışanlar Arası Işbirliği ve Güven
  - title: Müşteri Memnuniyeti Ölçme Teknikleri
    text: Çağdaş yönetim yaklaşımlarından Müşteri Odaklılık felsefesinde, müşterilerin tatminini ölçmek için planlama, analiz etme, uygulama ve raporlama konularında katılımcılara bilgi vermek ve bu konularda karar alma becerilerini geliştirmek
    list:
    - Müşteri Hizmetleri Yönetimi ve Müşteri Tatmini Felsefesi
    - Müşterilerinizin Beklentileri Nedir?
    - Neyi Ölçmek İstiyorsunuz? – Temel Ölçüm Konularının Belirlenmesi
    - Şirketiniz ve Müşterileriniz İçin En İyi Araştırma Tekniğinin Seçimi
    - "En Sık Başvurulan Araştırma Tekniği: Anket"
    - Ölçüm Hazırlığı ve Verilerin Toplanması
    - Müşteri Tatmini Ölçümü Analizi ve Sonuçlarının Değerlendirilmesi
    - Analiz Sonuçlarını Raporlamak
    - Analiz Sonuçlarının Şirket Yapısına ve Stratejilerine Etkisi
    - Müşteri Beklentilerindeki Değişiklikleri İzlemek
    - Geleceği Planlamak
  - title: Müzakere Teknikleri
    text: Müzakere sürecini tartışmaya açarak, iki taraf için başarılı bir müzakerenin şartlarını ortaya koymak, müzakereci davranışlarının temel belirleyicilerinden hareketle; müzakere stratejileri, müzakerede manevra, oyunlar ve taktikler uygulamalı bir şekilde gündeme getirmek
    list:
    - Müzakere Nedir ve Niçin Yapılır?
    - Müzakere Sürecinin Temel Unsurları
    - Müzakereci Karşı Taraf İlişkisi
    - Müzakerede Dikkat Edilmesi Gereken Hususlar
    - Müzakere Sürecinin Aşamaları
    - Müzakere Stratejileri
    - Müzakerelerde Manevra ve Oyunlar
    - Müzakere Teknikleri
    - Müzakere Becerileri
    - İdari ve Ticari Müzakereler
    - Müzakere Sürecinde Yasal Faktörler
  - title: Neuro Linguistic Programming
    text: Kişilerin amaçlarına ulaşmaları için nörolojik programlarını keşfetmelerini ve en iyi şekilde kullanmalarını sağlamayı hedefleyen, tartışmalı bir psikolojik terapi anlayışı
    list:
    - NLP’nin Doğuşu
    - NLP’nin Açılımı
    - NLP’nin Ön Kabulleri - İlkeleri
    - Dilimiz, İletişimimiz ve Davranışımız
    - İnsan Denilen Varlık
    - NLP’de Temsil Sistemleri
    - NLP’de Algımızı Etkileyen Faktörler
    - NLP’de Davranışı Anlamak
    - NLP’de Stratejiler ve Yeniden Çerçevelemek
  - title: Ofis Yönetimi
    text: Etkili ve verimli bir ofis yönetimi için gerekli koşulların değerlendirmesini yaparak, büro yönetimi ve organizasyon, ofis düzeni, resmi ve iş yazıları, evrak üretimi, dosyalama, evrak yönetimi ve arşiv gibi ofis uygulamaları hakkında bilgi vermek
    list:
    - Ofis Yönetimi ve Organizasyon
    - Ofiste Belge Üretimi ve Türleri
    - Yazışma Yöntemi
    - Evrak Yönetimi ve Arşiv
  - title: Pazarlık, İkna, Müzakere Becerilerini Geliştirme
    text: Bir satış görüşmesinde satıcıların, ürün, fikir ve hizmetlerini karşılıklı yarar sağlayacak koşullarda satabilmeleri, bir müzakerenin nasıl planlanması ve uygulanması gerektiğine ilişkin yöntem ve teknikler
    list:
    - Pazarlık - İkna - Müzakere Arasındaki Farklılıklar
    - Müzakere Süreci
    - Planlama ve Hazırlık Sürecinde Yapılması Gerekenler
    - Müzakere Stilleri ve Uygulamaları
    - Karşılaşılan Karşı Taktikler ve Önlemler
    - Müzakerelerde Strateji Geliştirme
  - title: Perakendecilikte Sunum ve Satış
    text: Perakende sektöründe faaliyet gösteren işletmelerde müşteri memnuniyetini yaratacak, çalışanlarda hizmet farklılığını ortaya koyacak sunum ve satış sürecinde etkili yaklaşımları geliştirmek
    list:
    - Perakendecilikte Müşteri Hizmeti Yaklaşımı
    - Kaliteli Hizmetin Fark Yaratan Unsurları
    - Sektörlere Göre Ürün ve Hizmet Sunumu
    - Müşteri Tipleri ve Yaklaşımlar
    - Müşterilerin Ihtiyaçlarının Tespiti
    - Kısıtlı Zamandaki Satış Süreci
    - Hazırlık ve Etkili Sunumun Getirileri
    - Ürün Bilgisinin Doğru Şekilde Sunumu
    - Satışı Gerçekleştirmek ve Çapraz Satış
    - Müşteri Memnuniyeti ve Bağımlılığı Yaratma
  - title: Pozitif Düşünce ile Mutlak Başarı
    text: Düşünceyi oluşturan kalıpların nasıl kazanıldığı, günümüzün gerektirdiği sınırın ötesinde düşünme yeteneğinin kazanılması için yapılacaklar ve bu kazanılan sistemle, problemlerin çözümüne nasıl bakarak karar verebileceğimiz, pozitif enerjiyi oluşturacak olan Pozitif Düşünme sisteminin kazanılması
    list:
    - Farklı Düşünce Yapısının Kazanılması
    - Pozitif Düşüncenin Ayırt Edilmesi
    - Kendini Tanıma-Testler
    - Pozitif Düşüncede Engeller
    - Stresin Fizyolojik Ve Psikolojik Yapısı
    - Stres Ve Başa  Çıkma
    - Negatiflerle Başa Çıkma
    - Pozitif Düşünceyi Teşvik
    - Pozitif Düşünceyi Kazanma
    - Sınırlarımızı Tanıma-Sınırın Ötesinde Düşünebilme
    - Kendi Kendini Motive Etmede Pozitif Düşüncenin Yeri
    - Pozitif Enerjinin Kullanılması
    - Başarıda Pozitif Düşüncenin Yeri
    - Beklentilerin Yeniden Gözden Geçirilmesi
    - Problemin Çözümündeki Bakış Açısı
    - Zihinsel Jimnastikler
    - Sağ Beyin Yarım Küresinin Kullanılması
    - Çözüm Bulmanın Planlanması
    - Hayal Gücü Tekniği
    - Problem Çözme Stratejisini Geliştirme
    - Karar Vermede Verilerin Gözden Geçirilmesi
    - Beyin Fırtınası
    - Kararlarda Etki Altında Kalmama
    - Grup Kararı
    - Başarıyı Oluşturma
  - title: Proje Yönetimi
    text: Belirli amaçlar çerçevesinde hazırlanacak projelerde, proje ekiplerinin başarılı olabilmesi için nelerin yapılması gerektiğini örneklerle tartışmaya açmak
    list:
    - Proje Yönetiminden Beklenenler
    - Proje Safhaları ve Proje Hayat Döngüsü
    - Proje Paydaşları
    - Organizasyonel Etkiler
    - Genel Yönetim Becerileri
    - Proje Süreçleri
    - Süreç Grupları ve Etkileşimleri
    - Proje Kapsamı
    - Projelerde Zaman Yönetimi
    - Projelerde Maliyet Yönetimi
    - Projelerde Kalite Yönetimi
    - Projelerde İnsan Kaynakları Yönetimi
    - Projelerde İletişim Yönetimi
    - Projelerde Satınalma Yönetimi
    - Projelerde Çizelgeleme
    - Katılımcıları Tanımak
    - İnsanlarla Çalışma ve Onları Yönetme
    - Liderlik
    - Projelerde Takip ve Kontrol
  - title: Raporlama Teknikleri
    text: Rapor hazırlama, raporlamanın önemi, rapor tipleri ve içerikleri ile raporlama standartlarının açıklanması
    list:
    - Rapor Hazırlama
    - Raporlama Türleri
    - İçerik Yönünden Raporlar
    - Raporun Bölümleri
    - Raporda Yazım Kuralları
    - Rapor Konusundaki Temel Şikayetler
    - İyi Rapor Yazmayı Engelleyen Faktörler
  - title: Stres Yönetimi
    text: Katılımcıları iş dünyasında karşı karşıya kaldıkları stres konusunda aydınlatmak, kapsamlı ve etkili başa çıkma yolları hakkında tartışarak çözüm yolları üzerinde konuşmak amacıyla hazırlanmıştır.
    list:
    - Stres ve Hayatımızdaki Önemi
    - Stresi Tanıyor Musunuz?
    - Stresi Hangi Koşullarda Yaşıyoruz?
    - Stres Düzeyimizi Neler Etkiler?
    - Stres Belirtileri
    - Stres Nasıl Kontrolden Çıkar?
    - Stresle Baş Etmede Olumsuz Etmenler
    - Stresin Sağlığımıza Etkisi
    - Keyifli ve Başarılı Bir Iş Hayatı Için En Uygun Stres Seviyesini Bulmak
    - Stresi Tanımak ve Iş Dünyasında Motivasyon Aracı Olarak Kullanmak
  - title: Takım Çalışması
    text: Takım çalışmasının önemini ve faydalarını, nasıl gerçekleşebileceğini ve gerekli becerileri uygulamalı bir biçimde aktarma
    list:
    - Takım Çalışmasının Önemi
    - Kalabalık Takımı Belirleyen Özellikler
    - Takımı Başarısızlığa Uğratan Faktörler
    - Takım Oluşturma Yöntemleri
    - Takım Çalışmasında Roller ve Sorumluluklar
    - Takımda Yönlendirme ve Motivasyon
    - Takım Çalışması Nasıl Yürütülür, Yönetilir?
    - Takım Çalışması Becerileri ve Araçları
    - Çatışma Yönetimi ve Uzlaşma Teknikleri
    - Liderlik ve Rehberlik Becerileri
    - "Takımdaşlıkta 3 Alan: Kalite, Verimlilik ve İlişkiler"
    - "Takımdaşlık Için: Sorumluluk, Bağlılık ve İnisiyatif"
  - title: Telefonda İletişim Teknikleri
    text: Çalışanların iletişim konusundaki becerilerini göstermede önemli bir araç olan telefonun kullanımı, etkinliği gibi konuları uygulamalı olarak katılımcılara aktarmak
    list:
    - Telefon Konuşmaları
    - Telefona Yanıt Verme
    - Telefonun Tehlikeleri
    - Doğru Konuşma Nasıl Olmalı
    - Sizin Aradığınız Telefonlar
    - Telefonda İş Konuşma Yöntemleri
    - Telefonda Kendini Doğru İfade Etme
    - Telefonu Kapatma
  - title: Uygulamalı Sunum Teknikleri
    text: Etkin sunum tekniklerini uygulamalı bir biçimde aktarmak, etkili konuşma ve stratejilere ilişkin uygulamalar
    list:
    - Başlamadan Önce Yapılması Gerekenler Ön Hazırlıklar
    - Düşüncelerin Düzenlenmesi
    - Sunuşa Son Şeklini Vermek
    - Prova Yapmak
    - Sunumda Etkiyi Arttırma
    - Sinirlerin Denetlenmesi
    - Güçlü Bir Etki Yaratma
    - Görsel Araçların Etkin Olarak Kullanılması
    - Sorular ve Cevaplandırma
    - Güç Durumların Ele Alınması
    - Etkili Konuşma İçin 10 Temel Kural
    - Stratejilere İlişkin Uygulamalar
  - title: Üstün Hizmet İçin Ortak Bilinç Oluşturma
    text: Daha iyiye yolculuk hareketinde; ortak bilince ulaşabilmek, temel yönetim ilkelerini paylaşmak, topyekün katılımı sağlamada engelleri tanıyarak, bu alanlara odaklanmak, süreçlerimizin iyileştirilmesine yönelik çalışmaları başlatmak
    list:
    - Kalite, Rekabet Etmede Bir Avantajdır
    - Organizasyon Kültürünün Etkilerini Tanımak
    - Planlı Hareket için Yapılanma
    - Sürekli Gelişme ve Yöntemleri
    - Herkesin Katılımını Sağlamak
    - Sıfır Hata Anlayışı
    - Müşteri Odaklı Yaklaşımın Benimsenmesi
    - Toplam Kalite Bir Süreçtir
    - İstatistiki Tekniğin Tanıtım ve Kullanımı
    - İç Müşterileri Memnun Etmek
    - Muayene Değil, Önleme Yaklaşımı
    - Tedarikten Müşteriye Süreç
    - Bürokrasi ve Olası Engellerin Tanınması
  - title: Yaratıcı Düşünme
    text: Çalışanların kişisel ve kurumsal ilişkilerinde ve iletişimlerinde; planlama, karar verme, uygulama, takip, kontol ve geri bildirim süreçlerinde, sıradışı düşünce gücüne ulaşıp, yeni yöntemler geliştirmelerini sağlamayı amaçlamak
    list:
    - Düşüncelerinde Esnek Olmak
    - Ortaya Çıkan Problemlere Farklı Çözümler Getirebilmek
    - Gerçekçi Planlara Dönüştürülebilen Yeni İş Anlayışları Yaratmak
    - Sıradışı Düşünce Gücünü İş Hayatına Uygulayabilmek
    - Sıradışı Kararlar İle Farklılık Yaratabilmek
    - Performansı Arttırmak İçin Yeni Fikirler Ortaya Çıkarmak
    - Metodlar, Süreçler Yaratmak ve Uygulamak
  - title: Zaman Yönetimi
    text: İnsanın kendisinin yaşama konuşlanış şekli ve zaman karşısındaki tavrı ile ilgili farkındalığını arttırmak, tavrımızın ve amaçlarımızın zaman yönetimi üzerindeki etkileri netleştirilerek, zaman yönetimi tuzakları ve bu tuzaklardan korunma stratejileri üzerinde odaklanmak
    list:
    - Başkalarından Önce Kendimizi Yönetmek
    - Zaman Kontrolünün En Önemli Koşulları
    - Zaman Tuzakları, Öncelikleri Bilmek, Ertelemek, Acelecilik, Kararsızlık
    - Verimsiz Toplantılar, Dağınık Masa
    - Hayır Diyememek
    - Zamanı Iyi Kullanmanın Yolları
    - Kısıtlı Zaman Stresinden Kurtulmanın  Anahtarı
    - Zamanını Yönetememenin Bedeli
    - Zamanımızı Yönetmekle İlgili Kötü Alışkanlıklarımız
    - Zaman Yönetiminin Temel Felsefesi
    - "Zamanı Planlamak: (Covey'in Zaman Yönetimi Matrisi)"
    - Zaman Tuzakları Nereye Gizlenir?
    - Öncelikleri ve Acil İşleri Belirlemek
    - Eylem Planı – Öneriler
- title: Yönetim Programları
  list:
  - title: "Coaching: Koç Yetiştirme Programı"
    text: Kuruluşların başarısını direkt etkileyen insan kaynağının iş tatminini sağlama ve kuruma bağlılığı ile verimliliğe katılımını sağlamada liderlik becerileri üzerinde düşünmek ve bu becerileri geliştirmek
    list:
    - Yönlendirmenin Mucizesi
    - Coaching Tanımı, Benzer Kavramlardan Farkı
    - Yönetici – Koç (Coach) Kavramları
    - Yönetim Yelpazesi
    - Sizin Tarzınız
    - Katılımcılık ve Durumsal Yaklaşım Modelleri
    - Etkili Bir Coaching Sürecinin Tanınması
    - Coaching Yeteneklerini Geliştirme
    - İnsan Davranışlarının İncelenmesi (Maslow)
    - Beceri ve İsteklerin Uyumlandırılması
    - Coaching Becerilerinde İletişim – Etkileşim
    - Dinleme Becerisi
    - Coaching Yönteminin Çalışması (Geri Bildirim)
    - Coaching Yaklaşımında Aşamalar
    - Bir Coaching Oturumunun Ana Başlıkları
  - title: Çağdaş Motivasyon Teknikleri
    text: Ekipteki çalışanların motivasyonunu arttırmayı hedefleyen yöneticilerin, hangi yol ve yöntemlerle bunu sağlayacaklarını tüm detayları ile aktarmak
    list:
    - Motivasyonun Tanımı ve Motivasyon Sürecinin Kuruluş Aşamaları
    - Motivasyon Araçlarının Belirlenmesi
    - Sosyo – ekonomik Araçlar ile Motivasyonun Sağlanması
    - Örgütsel ve Yönetsel Araçlar ile Motivasyonun Sağlanması
    - Motivasyon Teorileri
    - Çalışan Beklentilerinin İncelenmesi
    - Motivasyon Nasıl Artırma Teknikleri
    - Yöneticilerin Neler Yapması Gerektiğinin Belirlenmesi
    - Çalışanların Güvenini Arttırma Yöntemleri
    - Takdir Etmenin Önemli Unsurları ve Yöntemleri
    - Kurumsal Başarının Sırrı
    - Bireysel Motivasyon Sağlayıcı Çalışma Prensipleri
    - Çalışanların Moral Yönetimi
    - Çalışanların Motivasyonunu Saptama Anketi
    - Çalışanların Beklentileri Anketi Uygulaması
    - Davranış Belirleme Anketi Uygulaması
  - title: Değişim Yönetimi
    text: Değişimi sistem felsefesi bütünlüğüyle yaratabilme ve yönetebilme, değişimin gerektirdiği doğru stratejinin, kurum kültürü çerçevesinde uyumlu takımlar kurarak uygulanmasının sağlanması
    list:
    - Değişimi Sistem Felsefesi Bütünlüğüyle Yaratabilmek ve Yönetebilmek
    - Çalışanların Değişime İnanmasını Sağlamak
    - Değişimi Açıklayabilmek
    - Mevcut Sistemi Koruyan ve Değişme Direnmekten Vazgeçmeyen Çalışanların Değişime İkna Edilmesi
    - Çalışanlarda Değişimin Gerektirdiği Esnekliğin Sağlanması
    - Değişimin Gerektirdiği Doğru Stratejinin, Kurum Kültürü Çerçevesinde Uyumlu Takımlar Kurarak Uygulanmasının Sağlanması
  - title: Etkili Liderlik ve Vizyon Geliştirme
    text: Şirket stratejisini ve şirket kültürünü birleştirebilen liderlerin hem geniş bir vizyon sahibi olmalarını hem de bu vizyonu uygulayabilecek becerilere sahip olmalarını sağlanması
    list:
    - Etkin Liderlik Fonksiyonları
    - Planlama ve Organize Etme
    - Grup Dinamiklerini Yönlendirme
    - İletişim Süreci ve Iletişim Kanallarını Etkin Kullanma
    - Geri Bildirim Alma ve Verme Süreci
    - Yeni Yönetsel Gerçekler
    - Vizyon ve Başarı
    - Vizyonun Geliştirilmesi
    - Değişik Liderlik Tarzlarının Gözden Geçirilmesi
  - title: Hedeflerle Yönetim
    text: Çalışanların son derece net tanımlanmış amaç, hedef ve göstergeler kapsamında yönlendirilmesinin sağlanması
    list:
    - Yönetim Teorileri
    - Yönetici ve Yöneticilik Anlayışları
    - Bir Şirketin Organizasyonel Kurgusunun Ömrü ve Yönetim Şekilleri ile İlişkisi
    - Yönetim Anlayışları ve Organizasyonel Davranışlar
    - Hedeflerle Yönetimin, Şirket Stratejisi ve Şirket Kültüründeki Onemi
    - Hedef Belirleme Süreci ve İşleyişi
    - Klasik Performans Yönetimi
    - Hedefler, Beklentiler ve Ödüller
  - title: İleri Yönetici Geliştirme Programı
    text: Şirket kültürü ve stratejisini destekleyecek ideal bir yönetim anlayışının geliştirilmesi, bireylerin hedeflerinin kurumsal hedeflerle örtüşmesi sağlanarak şirketin performasının artırılması, yönetimin stratejik boyutunun uygulanması ve ilkelerin şirket düzeyinde uyarlanması için gerekli şartların sağlanması
    list:
    - Klasik ve Çağdaş Yönetim ve Yöneticilik Anlayışlarının Gelişimi
    - Bir Şirketin Organizasyonel Yapısının Ömrü ve Yönetim Şekilleri İle İlişkisi
    - Yönetim Anlayışına Uygun Bir Performans Yönetim Sistemi Kurgulama ve İşlerlik Kazandırma
    - Talimatlarla Yönetim
    - Hedeflerle Yönetim
    - Değerlerle Yönetim
    - Yönetim Anlayışındaki Yeni Paradigmaların Yönetime Etkileri
    - Yetki ve Sorumlulukların Delegasyonu
    - İnsiyatif Kullanma ve Karar Verme
    - Hedef Belirleme Süreci ve İşleyişi
    - Beklenti ve Ödüller
    - İletişim Kanallarını Etkin Kullanma
    - Ekip Çalışması İle Kişiler Arası İlişki Geliştirme
    - Çağdaş Motivasyon Teknikleri
  - title: İşletmelerde Performans Ölçümü ve Denetimi
    text: Şirketin rekabet avantajını yakalayabilmesi için rakipleri arasında nerede olduğunu, geçmiş performansı ile kıyaslamasını, hedefleri ile bulunduğu nokta arasındaki mesafeyi irdeleyebilmesini sağlamak
    list:
    - Verimlilik, Üretkenlik, Etkililik, Etkenlik Kavramları
    - Performans Yönetimi
    - Performans Ölçüm ve Denetim Sistemleri
    - Performans Göstergeleri
    - Toplam Performansın Ölçülmesi
    - Değer Mühendisliği
    - Değer Yönetimi Kavram ve Teknikleri
    - Değer Mühendisliğinin Aşamaları
  - title: Karar Verme ve Problem Çözme
    text: yöneticiliğin temelini oluşturan unsurlardan olan karar verme ve problem çözme becerisinin geliştirilmesini sağlamak
    list:
    - İş Yaşamının Kritik Anlarında, Mevcut Problem ile Bilinmeyen Çözüm Arasındaki En Uygun Denklemi Kurmak
    - Kritik Anlarda Gerekli Kişisel ve Kurumsal Riskleri Alabilecek Bir İnisiyatif Geliştirmek
    - Çözüme Giden Yolda İçsel ve Dışsal İletişimi En Yüksek Motivasyon ve Özgüven Enerjisi ile Desteklemek
    - Problemin Tanımı ve Kime Göre Problem Olduğunun Belirlenmesi
    - Sorun ve Çözüm Denkleminin Sağlanması
    - Karar Verme Ihtiyacı - Karar Verme Zevki ve Karar Verme Izdırabı
    - İçsel ve Dışsal İletişimimizin Duygu ve Düşüncelerimize Etkisi
    - Karar Anı ve En Uygun Kararı Vermek
    - Bireysel Stratejiler Geliştirmek
    - Takımdaşlık Stratejileri Geliştirmek
    - Bir Işi Başaran Insanların Başarısının Modellenmesi
    - Paradigmalar, Riskler ve Bakış Açıları
  - title: Kurumsal Yönetişim
    text: Şirketlerin mali piyasalara entegrasyonu için kaçınılmaz olan kurumsal yönetişim ilkelerin tanıtılması ve bu süreçlerin uygulamalı olarak incelenmesini amaçlamak
    list:
    - Kurumsal yönetişim ilkeleri
    - Kurumsal yönetişim uygulamaları
    - Kurumsal yönetişim uygulamalarının şirket ve finans piyasalarına katkıları
    - Stratejik yönetim ve stratejik planlama
    - İş planı gereksinimi, işin tanımlanması, şirketin kendi kimliğini kazanması
    - Rating süreci
    - Rating uygulamalarının yatırımcıya, şirketlere, ve genel ekonomiye katkıları
  - title: S.W.O.T. Analizi
    text: Çevre analizinden hareketle karşılaşılabilecek fırsatlar ve tehditler ele alınıp başarı faktörleri analiz edilerek, bir firmanın güçlü ve zayıf yönleri tartışılması
    list:
    - Swot Analizinin Stratejik Planlamadaki Yeri
    - Temel Kavramlar
    - Organizasyonu Tanımlama
    - Rakipleri Belirleme
    - Kaynakları Belirleme
    - Çevre Tanımlanması
    - Çevresel Değişimleri, Trendleri, Olayları Tanıma
    - Çevresel Değişimlerin, Trendlerin, Olayların Varlığını Gösterme
    - Çevresel Değişimlerin, Trendlerin, Olayların Etkisini Belirleme
    - Etkilerin Sonuçlarının Belirlenmesi ve Değerlendirilmesi
    - Yetkinlik Analizi
    - Endüstri Başarı Faktörlerini Belirleme
    - Endüstri Başarı Faktörlerini Firma Açısından Değerlendirme
    - Endüstri Başarı Faktörlerini Rakipler ve Endüstri Açısından Değerlendirme
    - Rekabet Üstünlüğü, Ayırımcı Üstünlük, Endüstri Standartı, Zayıflık, Ana Zayıflık Yönlerinin Belirlenmesi
    - Swot Sonuçlarını Kullanma
  - title: Stratejik Düşünme, Stratejik Yönetim
    text: Stratejik yönetim anlayışının yerleşmesi, stratejik düşünme ve strateji geliştirme konusunda yöneticilerin ve proje ekiplerinin, stratejik planlama, proje yönetimi ve başarılı uygulamalar konusunda eğitilerek yetkinlik kazanmalarına destek vermek
    list:
    - Kurumsal Stratejik Planlama Projesinin Planlanması ve Yapılandırılması
    - Stratejik Plan Hazırlama Süreci
    - Temel Yönetsel Değerlerin Gözden Geçirilmesi
    - Stratejik ve Uzun Vadeli Planlama Hedeflerinin Tanımlanması
    - Başarı Faktörlerinin Tanımlanması
    - Uygulama Stratejilerinin Tanımlanması
    - Boş Alan Analizi
    - Kurumsal Stratejik Plan Hazırlama Faaliyetlerinin Tanımlanması ve Planlanması
    - Stratejik Plan Hazırlama Projelerinin Yönetimi
    - Kurumsal Stratejik Plan Bütünleştirmesi
    - Kurumsal Stratejik Plan Tanıtım ve Paylaşımı
  - title: Stratejik Planlama
    text: Bir şirketin önümüzdeki yıllarda nereye, ne şekilde gitmek istediğini ve oraya ulaşıp ulaşmadığını nasıl denetleyeceği belirlenip her şirketin kendi kültürü ve öncelikleri doğrultusunda farklı yaklaşımların irdelenmesi
    list:
    - Stratejik Planlamaya Geçiş Hazırlığı
    - Dışardan Danışmanlık Hizmeti Alarak veya İçeriden Oluşturulacak Ekip İle Yola Çıkmak
    - İlgili Birim ve Yönetim Kademeleri ile Planlama
    - Planın Uygulanabilirliğini Güvenceye Almak
    - Stratejik Analiz
    - Swot Analizleri
    - Organizasyonel Zayıf Nokta Analizleri
    - Stratejik Yönlendirme
    - Stratejik Hedeflendirme ve Metot Tespiti
    - Stratejik Senkronizasyon
    - Aksiyonel Planlama
    - Şirket Stratejisinin Kaleme Alınması, Hedeflendirilmesi, Atanması
    - Şirket Stratejisi Uygulama Planının İzlenmesi ve Sapmaların Önlenerek Geliştirilmesi
    - Şirket Stratejisi Planlama Sürecinin Performans Yönetimi
  - title: Şirket İçi İletişim ve Davranış Geliştirme
    text: Kurum içi ilişkileri geliştirmeyi, iç müşteri kavramını herkese benimseterek, empatik bir anlayışla çalışma barışı oluşturmayı hedeflemek, bu amaçla kendini tanıma ile başlayan ve diğer insanlarla olan ilişkileri tanımlamak ve geliştirmek
    list:
    - Kurum içi İletişim
    - İnsan İlişkilerinde Karşılaşılabilecek Engelleri Çözümleyebilecek Analizci Bir Bakışa Sahip Olmak
    - Güçlü ve Zayıf Yönlerimizin Farkında Olmak
    - İletişime Etki Eden Özelliklerimiz
    - Baskın Kişilik Özelliklerimiz
    - Doğru Anlamak ve Anlaşılmak
    - Bireysel ve Kurumsal Uzlaşma Stratejileri Geliştirmek
    - Şirket içi Çatışmaları Önlemenin Yollarını Tanımlamak
    - Organizasyonel Davranış Geliştirme
    - Kişisel Tavır, Değer ve Tutumların Analizi
    - Kişilerarası Amaç, Hedef ve Değer Yargıları
  - title: Şirket Kültürü Oluşturma
    text: Kurumun vizyon ve misyonunu tanımlamak, şirket kültürünün yeni yönetsel yaklaşımdaki anlamını kavramak ve şirketin kültürel geçmişi ve geleceğini birleştirecek yapısal süreci tüm aşamaları ile incelemek
    list:
    - Kültür nedir? Şirket Kültürü nedir?
    - Şirketin Kültür Düzeyleri
    - Alt Kültürler, Yabancı Kültürler
    - Şirket Kültürünün Temel Öğeleri
    - Şirket Kültürünün Çalışanlar İçin Anlamı
    - Şirket Kültürünün Yönetimi, Tasarımı, Desteklenmesi ve Değişim Kültürü
    - İş Ahlakı ve Organizasyonel Kültür
  - title: Takım Oluşturma
    text: Ekip olma ve ekip çalışması yapabilme süreci örneklerle tanıtılıp ve ekip çalışmasında ortaya çıkan sorunları analiz etmede kullanılacak yöntemler irdelenmesi ve etkin bir ekip yönetimi için davranış geliştirme üzerinde durulması
    list:
    - Ekip Tanımı
    - Ekip Çalışması Engelleri
    - Ekip İçi İletişim
    - Başarılı Bir Ekip Oluşturmanın Faktörleri
    - Etkin Olan ve Olmayan Ekiplerin Özellikleri
    - Ekip Olma Süreci Aşamaları
    - Yüksek Performanslı Bir Takım Oluşturma
    - Ekip Içi Yapıcı ve Yıkıcı Davranışların Tanımlanması
    - Başkaları Üzerinde Etkili Olma
    - Liderlik Tarzları
    - Çatışmaları Çözmede Bir Yaklaşım
    - Ekipte Üye Rolleri
  - title: Temel Yönetici Geliştirme Programı
    text: Yönetimin temelini oluşturan planlama ve işleri organize etme, uygulama, kontrol ve yönlendirme becerilerinin geliştirilmesi
    list:
    - Yönetim, Yönetici Tanımı ve Sorumlulukları
    - Yönetimin Temel Fonksiyonları
    - Planlama ve Organize Etme
    - Koordinasyon
    - Uygulama ve Kontrol
    - Yönetimde Karar Verme İşlevi
    - İletişim Süreci ve Engelleri
    - Takım Çalışması ve Hedef Birliği Oluşturma
    - Motivasyon Teknikleri
  - title: Yöneticilikten Liderliğe Geçiş
    text: Katılımcıların liderlik hakkındaki becerilerini geliştirmek, yönetiminde liderlik yaklaşımlarının nasıl kullanıldığını anlamak ve karar alma süreçlerinde beceri sahibi olmayı amaçlamak
    list:
    - Çağdaş Yönetim Yaklaşımları İçinde Liderlik
    - Örgüt Yönetimini Etkileyen Liderlik Yaklaşımları
    - Örgüt Yönetiminde Liderlerin Sorumlulukları
    - Liderlik Yetkinliklerinin Öğrenilmesi
    - Etkin Liderlik Koşulu
    - Liderliğin Örgüt Kültürüne Etkisi
- title: Yönetim Sistemleri Programları
  list:
  - title: Altı Sigma Yaklaşımı
    text: Altı sigma yaklaşımı ve bu yaklaşımın uygulanışı, ana prosesleri ve müşterileri belirlemek, müşteri ihtiyaçlarını tanımlamak, mevcut performansı ölçmek
    list:
    - Altı Sigma Yaklaşımı ve Önemi
    - Altı Sigma Yaklaşımının Uygulanışı
    - Ana Prosesleri ve Müşterilerini Belirlemek
    - Müşteri İhtiyaçlarını Tanımlamak
    - Mevcut Performansı Ölçmek
    - Altı Sigma Prosesini Geliştirme
    - Altı Sigma Sistemini Uygulamak
    - Altı Sigma Yaklaşımını Hayata Geçirmek
    - Altı Sigma Çalışmalarına Nerede Ve Nasıl Başlamalıyız?
    - Altı Sigma Organizasyonu İçin Rolleri Belirlemek
    - Organizasyonun Altı Sigma İçin Önemi
    - Altı Sigma Uygulamasına Örnekler
  - title: Benchmarking
    text: Ürün / hizmet kalitesinin veya süreçlerin iyileştirilmesine yönelik olarak kullanılan tekniklerden birisi olan benchmarking hakkında katılımcıların bilgilendirilmesi ve uygulamaya yönelik adımların açıklanması
    list:
    - Kıyaslamanın Tanımı
    - Kıyaslama Çeşitleri ve Modelleri
    - Kıyaslama Modelleri ve Engelleri
    - Kıyaslamanın Dört Adımı
    - Nasıl Kıyaslamalıyız, Kiminle Kıyaslamalıyız?
    - Kıyaslamada Yapılan Hatalar
    - Kıyaslama ile Toplam Kaliteye Giden Yol
    - Uygulamalar ve Örnekler ile Alıştırmalar
  - title: Değişim Mühendisliği
    text: Değişim mühendisliğinin farklı yaklaşımı, değişim mühendisliği teknikleri, değişim mühendisliğinde aşamalar, değişim yönetiminde izlenecek stratejinin, şirket stratejisi doğrultusunda ayarlanması
    list:
    - Değişim Mühendisliğinin Farklı Yaklaşımı
    - Süreç Odaklılık
    - İş Süreçleri
    - Değişim Mühendisliği Teknikleri
    - İş Basitleştirme
    - Yeniden Yapılanma
    - Dönüşüm
    - Değişim Mühendisliğinde Aşamalar
    - Süreç Yönetimi
    - Süreç Haritaları
    - Süreç Performansı
    - Değişim Yönetiminde İzlenecek Stratejinin, Şirket Stratejisi Doğrultusunda Ayarlanması
    - Değişim Mühendisliğinde; Proje Ekibi, Proje Müşterisi, Hissedarlar ve diğer Rollerin tanımlanması
  - title: Hata Modu ve Etki Analizi (FMEA)
    text: FMEA çalışmasının amacı ve ürün tanımlaması, proje ekibinin belirlenmesi, proses FMEA, tasarım FMEA, çalışma sonuçlarının değerlendirilmesi
    list:
    - FMEA Çalışmasının Amacı ve Ürün Tanımlaması
    - Proje Ekibinin Belirlenmesi
    - Proses FMEA
    - Tasarım FMEA
    - FMEA Çalışma Sonuçlarının Değerlendirilmesi
  - title: Hizmet Kalitesini Geliştirme Teknikleri
    text: Ürünlerin ve hizmet kalitesinin iyileştirilmesi ve bu yolla müşteri memnuniyetinin artırılmasında yararlanılabilecek tekniklerin uygulamaya dönük olarak açıklanması
    list:
    - Toplam Kalite Anlayışı ve Sürekli İyileştirme
    - Sürekli İyileştirme Teknikleri ve Kullanım Alanları
    - Kalite – Verimlilik İlişkisi
    - Beyin Fırtınası ve Veri Toplama Teknikleri
    - İş Akış Diyagramları
    - Değişkenlik ve Histogramlar
    - Normal Dağılım ve Pareto Analizi
    - Neden-Sonuç Analizi
    - Kontrol Çizelgeleri ve İlişki Diyagramları
    - Fayda - Maliyet Analizi ve Kuvvet Alan Analizi
  - title: ISO 14001 Çevre Yönetim Sistemi Bilinçlendirme
    text: Katılımcıların Çevre ve Çevre Yönetimi, ISO 14001:1996 standardı, standart gerekliliklerine göre ÇYS’nin kurulması ve sürdürülmesi, çevre ile ilgili yerel düzenlemeler, ISO 14001’in diğer yönetim sistemleri ile uyumu hakkında bilgi sahibi olmalarını amaçlamak
    list:
    - Çevre ve Çevre Yönetimi Esasları ve Tanımlar
    - Çevre Mevzuatı
    - Çevre Yönetim Sistemi ISO 14001:1996
    - Ulusal, Yerel ve Uluslararası Düzenlemeler, Yönetmelikler
    - Çevre Unsurları ve Çevre Etkileri
    - Çevre Yönetim Sisteminin oluşturulması
    - Diğer Yönetim Sistemleri ile Benzerlikler / Farklılıklar
  - title: ISO 14001 Çevre Yönetim Sistemi İç Denetçi Eğitimi
    text: ISO 14001:1996 Çevre Yönetim Sistemi standardını yorumlayabilen, Kalite Yönetim ve Çevre Yönetim Sistemleri arasındaki benzerlik / farklılıkları anlamış, Denetim gerekliliklerini kavramış ve etkin bir şekilde denetim gerçekleştirebilecek denetçiler yetiştirmek
    list:
    - Çevre Yönetim Standardının ve ISO 14001’nin gelişimi
    - Çevre ve Çevre Yönetim Sistemi Genel Açıklamaları
    - Çevre ve Kalite Yönetim Sistemlerinin  Bağlantıları
    - ISO 14001 Denetim Teknikleri ve Uygulamaları
    - Denetimin Raporlanması
    - Denetimin Takibi
  - title: ISO 9001:2000 Kalite Yönetim Sistemi Bilinçlendirme
    text: Kalite bilincinin oluşturulması ve ortak dil birliğinin sağlanması, ISO 9000 ve Kalite Güvence Sisteminin kurulması için tüm gerekliliklerin anlatılması
    list:
    - Kalite Nedir? Kalite İle İlgili Temel Kavramlar
    - ISO 9000 Nedir?
    - ISO 9000’in Tarihsel Gelişimi
    - Kalite Güvence Sisteminin ve Belgelendirmenin Yararı
    - ISO 9000 Serisi Standartların Tanıtımı
    - ISO 9001 Standart Maddelerinin Kapsamlı Açıklaması
  - title: ISO 9001:2000 Kalite Yönetim Sistemi İç Denetçi Eğitimi
    text: Kalite bilinci yükselmiş, ISO 9000 standardını ve kalite yönetim sistemini sistematik ve objektif olarak yorumlayarak gelişimine katkıda bulunabilen, denetim konularında gerekli bilgilerle donatılmış, kuruluş içinde etkin olarak denetim yapabilecek denetçiler yetiştirmek
    list:
    - Kalite Sistemleri ve Standartları
    - Denetim Standartları
    - Denetimin Tanımı, Amaçları ve Tipleri
    - Denetçi Özellikleri, Görev ve Sorumluluklar
    - Denetime Hazırlık ve Denetimin Gerçekleştirilmesi
    - Denetimin Raporlanması ve Sonuçların İzlenmesi
  - title: İstatistiki Analiz ve Karar Verme
    text: Kalite geliştirme faliyetlerinin temelini oluşturan istatistiki analiz yöntemlerini öğretmek ve karar verme teknikleri hakkında uygulama örnekleriyle birlikte bilgi vermek
    list:
    - İstatistiki Analiz ve Karar Verme Teknikleri
    - Çetele Tablosu ve Histogram
    - Pareto Analizi
    - Neden – Sonuç Analizi (Balık Kılçığı Diyagramı)
    - Takım Çalışması ve Beyin Fırtınası
    - Dağılım ve Korelasyon
    - Gruplandırma
    - 7 Adımda Problem Çözme
  - title: İş Etüdü
    text: Katılımcılara işletmelerde planlama, maliyetlendirme, ücretlendirme ve iş düzenleme için gerekli olan zaman verilerinin belirlenmesi, çalışma koşullarının iyileştirilmesi, iş basitleştirme, akış düzenleme konularında verimliliği artırıcı teknikleri öğretmek
    list:
    - Süreç Tanımı ve İş Akış Analizi
    - Sentez (Sipariş Sürelerinin Belirlenmesi)
    - Süreç Performanslarının Değerlendirilmesi
    - Tempo Belirleme (Video Kaset Gösterimi)
    - Zaman Ölçme Yöntemi (Uygulamalı)
    - Verilerin İstatistiksel Değerlendirmesi
    - Kayıp Zaman Analizi ve Ek Payların Belirlenmesi
    - Standart Zamanların Hesaplanması
    - Süreç İyileştirme ve İş Basitleştirme
  - title: Kaliteli Bir İş Çevresinin Yaratılması
    text: Kaliteli bir iş çevresinin oluşturulmasında etken olan insan, proses ve teknoloji gibi temel dinamiklerin önemi ve kaliteli iş çevresinin sağlanmasındaki rolü ile bu temel dinamiklerin birbiriyle etkileşimlerinin ortaya konulması
    list:
    - Kalitede İnsan Faktörü
    - Proses Yaklaşımı ve Proses Kalitesi
    - Teknolojik Altyapı ve Çalışma Ortamı Kalitesi
    - İnsan, Proses ve  Teknolojinin Birbiriyle Etkileşimleri
    - Dengeleme Yaklaşımı
    - Kaliteli Bir Iş Çevresinin Oluşturulmasında İkicil Unsurlar
    - Kaliteli İş Çevresinin Yönetimi
  - title: Kritik Kontrol Noktalarında Risk Analizi (HACCP)
    text: Gıda hijyeni konusunda bilgi sahibi olan, gıdalar ile ilgili tehlikeleri yorumlayabilen, gıda üretimi ve servisi aşamalarında kritik kontrol noktaları tespit edebilecek, alınması gereken önlemleri belirleyebilen ve HACCP Sistemini oluşturabilecek sorumluların ve uygulayacak çalışanların yetiştirilmesi
    list:
    - HACCP Sistemi Tarihçe ve Tanımlar
    - Ürün Tanımlaması ve Akış Diyagramları
    - Tehlike Analizi ve Kontrol Tedbirleri
    - Kritik Kontrol Noktalarının Tespiti ve  Kritik Limitler
    - İzleme Yöntemleri ve Düzeltici Faaliyetler
    - Tehlikeler (Mikrobiyolojik, Kimyasal, Fiziksel)
    - Ön Yeterlilik Programı (Hijyen Sistemi)
    - HACCP Sisteminin ISO 9000 Sistemi ile Entegrasyonu
    - Genel Plan Örnekleri ve Pratik Çalışma
  - title: OHSAS 18001 İş Sağlığı ve Güvenliği İç Denetçi Eğitimi
    text: OHSAS 18001 İş Sağlığı ve Güvenliği Yönetim Sistemi gerekliliklerine uygun denetim yapabilecek, OHSAS 18001 maddelerini yorumlayabilen, denetim gerekliliklerini kavramış ve etkin bir şekilde denetim gerçekleştirebilecek denetçiler yetiştirmek
    list:
    - OHSAS 18001 Yönetim Sisteminin Gelişimi ve Tanımlar
    - İş Sağlığı ve Güvenliği Sisteminde Kullanılan Terminoloji
    - Ulusal ve Uluslararası Yönetmeliklerin Tanımı
    - OHSAS 18001 Maddeleri
    - Denetim Gereklilikleri
    - Denetimin Yönetimi, Raporlanması ve Takibi
  - title: OHSAS 18001 İş Sağlığı ve Güvenliği Yönetim Sistemi Bilinçlendirme
    text: Katılımcıları OHSAS 18001 İş Sağlığı ve Güvenliği Yönetim Sisteminin yürütülmesi ile ilgili sistem şartlarının ve mevzuatın tanıtımı, sistem ve sistemin kurulması konusunda bilinçlendirmek
    list:
    - İş Sağlığı ve Güvenliği Kavramları
    - Uluslararası İSG Uygulamaları
    - OHSAS 18001 Yönetim Maddeleri
    - Risk Değerlendirme Kavramına Genel Bakış
    - Risk Değerlendirme Grup Çalışması
  - title: Problem Çözme Teknikleri
    text: Çalışanlara bir ekip ruhu içinde işletmelerinde karşılaşacakları problemleri çözmek için kullanacakları yöntem ve metodları tanıtmak ve onları uygulamalı olarak etkin kalite geliştirme araçlarını kullanabilir hale getirmek
    list:
    - Ekip Kurma
    - Toplantı Esasları
    - Beyin Fırtınası
    - Veri Toplama
    - Gruplandırma
    - Dağılım Diyagramları
    - Histogram
    - Pareto Şeması
    - Neden-Sonuç (Ishikawa) Diyagramı
    - Problem Analizi (8-D Report)
    - Düzeltici Aksiyon
  - title: Satın Alma ve Tedarikçi Değerlendirme
    text: Satın alma tekniklerinin ve tedarikçi değerlendirmenin detayları, satın alma yönetimi değerlendirmesi
    list:
    - Satın Alma ve Kar; Kar Çarpanı
    - Satın Almanın Beş Temel Doğrusu (Zaman, Fiyat, Miktar, Kalite, Kaynak)
    - Satın Alma Biçimleri (Doğrudan Satınalma, Leasing Kiralama)
    - Satın Almada Değer Analizi İçin 10 Temel Soru
    - Stok Kontrolde ABC Yöntemi
    - A/B/C Sınıflamasındaki Stok Kalemlerinin Servis Özellikleri
    - Stok Kontrolde Ekonomik Sipariş Miktarı Modeli
    - Stok Kontrolde Çeşitli Sipariş Miktarları ve Ortalama
    - Envanter Düzeyleri
    - Sürekli Gözden Geçirme Politikası İçin Yeniden Sipariş Noktası
    - Periyodik Gözden Geçirme Politikası İçin Yeniden Sipariş Noktası
    - Tedarikçi Performansının Değerlendirilmesi
    - Satın Alma Yönetimi Değerlendirmesi
    - Kalite Sistem Diyagramı
    - Satın Alma İstek Formu
    - Sipariş Emri ve Satın Almada Diğer Formlar
    - Uluslararası Satın Alma
    - Kurlardaki Değişmelerin Satın Alma Üzerindeki Etkisi
  - title: Sipariş ve Stok Yönetimi
    text: Üretim sistemlerinde stok kavramını açıklamak, tedarik, sevkiyat, depolama ve stok yönetimine ilişkin temel kavramları aktarmak
    list:
    - Üretim Sistemlerinde Stok Kavramı
    - Stokların Sınıflandırılması ve İşletme Ekonomisindeki Önemi
    - Stok Kontrolünün Organizasyondaki Yeri
    - Stok Kontrolünden Etkilenen Maliyet Unsurları
    - Tedarik, Sevkiyat ve Depolama
    - Stok Kayıtları ve Stok Kontrol Yöntemleri
    - Belirsizlik Halinde Stok Kontrolü
    - Stok Kontrolünde Bilişim Teknolojileri
  - title: Süreç Yönetimi ve İyileştirme
    text: Süreç yaklaşımının şirket çalışanları tarafından özümsenmesinin uzun soluklu çalışmaların temelini oluşturacağı anlayışının aktarılması
    list:
    - Süreç Tanımı
    - Süreç Yönetiminin Gerekliliğinin Açıklanması
    - Süreçlerin Belirlenmesi
    - Süreç Özellikleri
    - Süreçlerin Sınıflandırılması
    - Sürecin Temel Unsurları
    - Süreç Hiyerarşisi
    - Süreçlerin Performans Göstergelerinin Belirlenmesi
    - Süreç Performanslarının İzlenmesi
    - Akış Diyagramları
    - Kuruluş Amaç ve Hedefleri ile Süreç Performans Göstergelerinin İlişkilendirilmesi
    - Kritik Süreçlerin Belirlenmesi
    - Süreç Analizi ve Geliştirme Yöntemi
  - title: Tam Zamanında Üretim
    text: Tam Zamanında Üretim felsefesi, amaçları, elemanları ve tüm detayları, üretim süreçlerinin iyileştirilmesi
    list:
    - Tam Zamanında Üretim Felsefesi
    - Tam Zamanında Üretim Sistemlerinin Amaçları
    - Tam Zamanında Üretim Sistemlerinin Elemanları
    - Üretim Süreçlerinin İyileştirilmesi
    - Genel Süreç Yönetimi Kavramı
    - Süreç Analizi
    - Süreç Geliştirme
  - title: Tedarikçi Yönetimi
    text: Tedarik edilen malzeme ve hizmetler bazında kritiklik değerlendirmesi, tedarikçi seçimi ve yeterlilik bakımından değerlendirilmesi ile tedarikçi performans kriterlerinin tamamlanması ve ölçümlenmesi
    list:
    - Tedarik Zinciri Yönetimi
    - Simulatör ile Gruplara Oyun Oynatma
    - Temel Lojistik Faaliyetleri, Destek Faaliyetler
    - Strateji ve Planlama
    - Üretim ile Ilgili Startejiler ve Üretim Çizelgesi Oluşturulması
    - Ürün Tahsisi
    - Depolama ve Stok Yönetimi
    - Müşteri Hizmet Düzeyi
    - Ulaşım, Ulaştırma Türü Seçimi ve Yer Seçimi
  - title: Temel Kalite Yönetimi
    text: Üst ve orta kademe yöneticileri Toplam Kalite, Kalitenin Temel İlkeleri üzerine bilgilendirmek ve firmanın bu doğrultuda örgütlenmesinin gerekliliğini vurgulamak
    list:
    - Stratejik Planlama
    - Rekabet Üstünlüğü
    - Müşteri Tatmini
    - Sıfır Hata
    - Firma Kültürü
    - Değişim
    - Sürekli Gelişim
    - Takım Oyunu
  - title: Temizlik ve Düzen (5S)
    text: Temizlik ve Düzenin hayatımızdaki önemini kavramak, standartlaştırmak, iş ve sosyal yaşantımıza uygulamak, 5S yönteminin ne olduğunu, nasıl uygulanması gerektiğini belirlemek
    list:
    - Temizlik Nedir?
    - Bizlere Düşen Görev ve Sorumluluklar
    - 5S Yönetimi
    - (SEIRI) Sınıflandırma
    - (SEITON) Düzenleme
    - (SEISO) Temizlik
    - (SEIKETSU) Standartlaştırma
    - (SHITSUKE) Disiplin
  - title: Toplam Üretken Bakım
    text: İstatistiki yöntemlerin kullanılarak arıza nedenlerinin analiz edilmesi, arıza ve bakım oranlarının ve maliyetlerinin düşürülmesi ve verimliliğin artırılması
    list:
    - TPM yaklaşımı nedir? Nasıl Kullanılır?
    - Hata Aysbergi
    - Üretimde 6 Kayıp ve Mücadele Yolları
    - Bakımda Müşteri Odaklılık
    - Bakımda Yetki Paylaşımı
    - Just In Time (JIT) Tam Zamanında - TPM ilişkisi
    - TPM’de Görevler ve İletişim
    - Temizlik Muayenedir!
    - OEE (Toplam Ekipman Etkinliği) Hesabı ve Kullanılması
    - TPM Kurulum Aşamaları
  - title: Üretim Planlama ve Stok Kontrol Teknikleri
    text: Kısa sürede teslimatı mümkün olan en düşük maliyet ile, esnek üretimden fedakarlık etmeden gerçekleştirmenin yolları
    list:
    - Üretim Sistemlerinde Kullanılan Kavramlar ve Yaklaşımlar
    - Şirket Rekâbet Gücünü Arttırmada Üretim-Stok Stratejileri
    - Üretim, Üretim Sistemleri ve Verimlilik
    - Yalın Üretim, İsraflar ve 5S
    - Talep Tahminleri ve Ana Üretim Çizelgesi Oluşturma
    - Malzeme İhtiyaç Planlaması Tabanlı Üretim Planlaması
    - Hücresel Üretim ve Yönetim
    - Hazırlık Sürelerinin Analizi ve Düşürülmesi
    - Stok Kontrol Parametrelerinin Elde Edilmesi ve Uygulanması
    - İtme ve Çekme Sistemleri
    - Sonlu Kapasite Çizelgesi Oluşturma
    - Periyodik Parti Kontrolü
    - Görsel Üretim Kontrolü
    - Üretim Süreçlerinin İyileştirilmesi ve Dengeleme Süreci
    - Tedarikçi Programlarını Kurma ve Geliştirme
    - Faaliyet Tabanlı Maliyetlendirme
  - title: Üretim Sistemlerinde Yeni Yaklaşımlar  
    text: Günümüzdeki rekabet şartlarını sağlamak için müşteri istekleri doğrultusunda ortaya çıkan modern üretim sistemlerine ait felsefeleri, prensipleri ve uygulamaları klasik üretim sistemleri ile karşılaştırarak açıklamak
    list:
    - Grup Teknolojisi
    - Hücresel Üretim Sistemi
    - TZÜ / Yalın Üretim / Yönetim
    - Hızlı Tepkisel Üretim
    - Çevik Üretim
  - title: Ürün Geliştirme
    text: Ürün geliştirme sürecindeki olguları, pazar ve kullanıcı istekleri, hata modu ve etkileri analiz etmek
    list:
    - Ürün Geliştirme Süreci
    - Sıralı Mühendislik
    - Eş Zamanlı Mühendislik
    - Pazar ve Kullanıcı İsteklerinin Belirlenmesi
    - Ürün Tasarım Özellikleri
    - Kavramsal Tasarım
    - Ayrıntılı Tasarım
    - Kalite Fonksiyon Açılımı
    - Deney Tasarımı
    - Hata Modu ve Etkileri Analizi
    - Değer Analizi
  - title: Verimlilik Ölçme ve Değerlendirme
    text: Verimliliğin önemi ve verimlilik bilincinin, verimlilik-üretkenlik ilişkisinin, verimsizlik döngüsünün, verimlilik ölçümünün analizi, değerlendirilmesi ve artırılması aşamalarını içeren verimlilik yönetim sisteminin açıklanması
    list:
    - Verimlilik ve Üretkenlik Kavramları ve Önemleri, Verimlilik ile İlgili Diğer Kavramlar
    - Verimlilik ve Üretkenlik Bilinci Oluşturulmasının Önemi
    - Verimlilik Yönetim Sistemi; Verimliliğin Ölçülmesi, Değerlendirilmesi ve Geliştirilmesi
    - Verimlilik Ölçme Amaçları
    - Verimlilik Ölçümündeki Genel Yapı
    - Verimlilik Ölçümündeki Temel Adımlar
    - Verimlilik Oranları ve Özellikleri
    - Mali Verimlilik Oranları
    - Verimlilik Oranlarının Sınıflandırılması
    - Verimlilik Oranlarında Kullanılan Kavramlar
    - Verimlilik Analizi ve Değerlendirme
    - Verimlilik Değerlendirmede Kullanılan Oranlar
